import { render, staticRenderFns } from "./AddRemoveMoney.vue?vue&type=template&id=ab5fce8e&scoped=true&"
import script from "./AddRemoveMoney.vue?vue&type=script&lang=js&"
export * from "./AddRemoveMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5fce8e",
  null
  
)

export default component.exports